import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { generateId, shortHandDate } from '../../../utility/functions';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';
import { IsAuthorized, userRoles } from '../../../RoleProtected';

const SubscriptionRedemptions = ({ ...props }) => {
    const canViewCustomers = IsAuthorized(userRoles.viewCustomers);

    // Wash Club members link to their app user page, ExpressPass members to their loyalty account
    const renderCustomerLink = (e) => {
        if (!canViewCustomers || (!e.userId && !e.loyaltyAccountId)) return e.customerName;

        return (
            <LinkTo target='_blank' customerId={e.userId} loyaltyAccountId={e.loyaltyAccountId}>
                {e.customerName}
            </LinkTo>
        );
    };

    // ExpressPass members can't redeem with the app or a timer, so show a dash instead of 0
    const isExpressPass = (e) => e.subscriptionType === 'ExpressPass';

    const tableConfig = {
        getData: QuestRoute.reports.subscriptionRedemptions,
        headers: [
            {
                label: 'Customer',
                propKey: 'customerName',
                options: true,
            }, {
                label: 'Email',
                propKey: 'email',
            }, {
                label: 'Type',
                propKey: 'subscriptionType',
                options: true,
            }, {
                label: 'Plan',
                propKey: 'clubName',
                options: true,
            }, {
                label: 'Billing Day',
                propKey: 'billingDay',
            }, {
                label: 'Last Billed',
                propKey: 'lastBillingDate',
            }, {
                label: 'Pass Uses',
                propKey: 'passUsagesSinceLastBilling',
            }, {
                label: 'App Uses',
                propKey: 'usagesSinceLastBilling',
            }, {
                label: 'Timer Uses',
                propKey: 'timeUsagesSinceLastBilling',
            },
        ],
        renderFormat: (e) => (
            <tr key={generateId()}>
                <td>{renderCustomerLink(e)}</td>
                <td>{e.email}</td>
                <td>{e.subscriptionType}</td>
                <td>{e.clubName}</td>
                <td>{e.billingDay}</td>
                <td>{shortHandDate(e.lastBillingDate)}</td>
                <td>{e.passUsagesSinceLastBilling}</td>
                <td>{isExpressPass(e) ? '-' : e.usagesSinceLastBilling}</td>
                <td>{isExpressPass(e) ? '-' : e.timeUsagesSinceLastBilling}</td>
            </tr>
        ),
    }

    return (
        <Table config={tableConfig} />
    );
}

export default SubscriptionRedemptions;
